import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { Snackbar, Alert } from "@mui/material";

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [state, setState] = useState({ open: false, severity: "info", message: "" });

  const show = useCallback((severity, message) => {
    setState({ open: true, severity, message });
  }, []);

  const api = useMemo(
    () => ({
      success: (m) => show("success", m),
      error: (m) => show("error", m),
      info: (m) => show("info", m),
      warning: (m) => show("warning", m),
    }),
    [show]
  );

  const handleClose = (_, reason) => {
    if (reason === "clickaway") return;
    setState((s) => ({ ...s, open: false }));
  };

  return (
    <ToastContext.Provider value={api}>
      {children}
      <Snackbar
        open={state.open}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        // MUI varsayilan olarak pencere odagi kaybolunca otomatik kapanma
        // sayacini duraklatiyor; kullanici baska bir pencereye (ornegin
        // DevTools'a) gectiginde toast ekranda takili kaliyordu.
        disableWindowBlurListener
      >
        <Alert severity={state.severity} onClose={handleClose} sx={{ width: "100%" }}>
          {state.message}
        </Alert>
      </Snackbar>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error("useToast must be used within ToastProvider");
  return ctx;
}
